<script lang="ts"></script>

<template>
  <div class="bg-primary">
    <div class="flex min-h-dvh flex-col items-center md:justify-center">
      <NuxtLink to="/login" class="mb-6 w-full flex md:justify-center justify-start px-5">
        <!-- width="191" -->

      </NuxtLink>
      <slot />
    </div>
  </div>
</template>
